import React from 'react';
import MarkModal from '../../components/MarkModal';
import Button from '@hero/ui-kit/inputs/Button';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import type { SegmentUsage } from '../../types';
import SegmentUsedByList from './SegmentUsedByList';
type Props = {
    usedBy: SegmentUsage;
    isPending: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    action: 'save' | 'replace';
};
const UsedByModal: React.FC<Props> = ({ usedBy, isPending, onConfirm, onCancel, action }) => (
    <MarkModal
        aria-label="Segment in use"
        isPending={isPending}
        type="warn"
        isCancelable={!isPending}
        onClose={onCancel}
        styles={{
            width: '64rem',
            maxWidth: '90vw',
            padding: '3.2rem'
        }}
    >
        <H role="h4">Segment in use</H>
        <P>
            This segment is used by {usedBy.drips.length} drip(s) and {usedBy.blasts.length}{' '}
            blast(s).
            {action === 'save' ? ' Saving' : ' Replacing it'} will affect those campaigns.
        </P>
        <SegmentUsedByList usedBy={usedBy} />
        <div
            style={{
                display: 'flex',
                gap: '1.2rem',
                marginTop: '2.4rem'
            }}
        >
            <Button disabled={isPending} variant="inverted" onClick={onConfirm}>
                {isPending
                    ? action === 'save'
                        ? 'Saving...'
                        : 'Importing...'
                    : action === 'save'
                      ? 'Confirm & save'
                      : 'Confirm & replace'}
            </Button>
            <Button disabled={isPending} variant="secondary" onClick={onCancel}>
                Cancel
            </Button>
        </div>
    </MarkModal>
);
export default UsedByModal;
